// extracted by mini-css-extract-plugin
module.exports = {"rockets":"_1l2BB9DerrLoCBpsSnj7-5"};